import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__arrow-minus",
  "use": "icon__arrow-minus-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"icon__arrow-minus\"><path d=\"M7 1 1 7l6 6\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol